import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import { getState } from "../helpers/getState";
import { updateCart } from "../helpers/updateCart";
import { getProduct } from "../helpers/getProduct-v7";
import { getRout } from "../helpers/getRout";
import {setContacts} from "../helpers/setContacts";
import {subscribeForm} from "../helpers/subscribeForm";
import '../helpers/slick.min.js';

updateCart()
getRout()
subscribeForm()



getState((data) => {

  const $loader = $('.popup-loading-wrapper');

  const products = data.data.products;

  setContacts(data.data.templates)

  getProduct(products, 'ha-product__content');

  getProduct(products, 'home-product__content');

  getProduct(products, 'banner-flex');

  getProduct(products, 'marquee-track');
 




  const slider = $('.testimonial-slider .slider');

  const names = ['Alice', 'James', 'Emma', 'Olivia', 'Liam', 'Sophia', 'Lucas', 'Mia', 'Noah', 'Isabella'];

  function getRandomName() {
    return names[Math.floor(Math.random() * names.length)];
  }


  products.forEach(product => {
    if (product.reviews && typeof product.reviews === 'string') {
      const author = getRandomName();

      const slideHTML = `
        <div class="slide">
          <p>${product.reviews}</p>
          <span class="author">— ${author}</span>
        </div>
      `;

      slider.append(slideHTML);
    }
  });


    $('.slider').slick({
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev custom-arrow">❮</button>',
      nextArrow: '<button type="button" class="slick-next custom-arrow">❯</button>',
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  

  $loader.hide();
});
